import React, { useCallback } from 'react';
import { isNull } from 'lodash/fp';

import { useAppDispatch } from '../../../hooks/react-redux';
import { deletePortfolioAnalyticsTemplateStarted } from './store';
import styles from './PortfolioAnalytics.module.scss';
import { ConfirmationModal } from '../../shared/modal/ConfirmationModal';
import { ModalHeader } from '../../shared/modal/ModalHeader';
import { Delete } from '../../shared/icons';

const { red } = styles;

interface PortfolioAnalyticsTemplateDeleteModalProps {
    templateIdToDelete: number | null
    setTemplateIdToDelete: (view: number | null) => void;
}

export const PortfolioAnalyticsTemplateDeleteModal: React.FC<PortfolioAnalyticsTemplateDeleteModalProps> = ({ templateIdToDelete, setTemplateIdToDelete }) => {

    const dispatch = useAppDispatch();

    const deleteTemplate = useCallback(() => {
        dispatch(deletePortfolioAnalyticsTemplateStarted(templateIdToDelete!));
        setTemplateIdToDelete(null);
    }, [dispatch, templateIdToDelete, setTemplateIdToDelete]);

    return (
        <ConfirmationModal
            isOpen={!isNull(templateIdToDelete)}
            closeModal={() => setTemplateIdToDelete(null)}
            confirm={deleteTemplate}
            spaceBetweenButtons={true}
        >
            <div className={styles.deleteTemplateModalWrapper}>
                <ModalHeader
                    testId='portfolio-analytics-delete-template'
                    label='Delete Template'
                    icon={Delete}
                    iconColor={red}
                />
                <div className={styles.deleteWarning}>
                    This will permanently delete the template and cannot be undone, are you sure you wish to delete this?
                </div>
            </div>
        </ConfirmationModal>
    );
};
